import { Log } from '../AuxillaryService/Log';
import { Scheduler } from '../Utility/Scheduler';
import { Display, getDisplayById, getDisplays, setCurrentDisplayId } from '../Display';

function makeVisible(displayId: number): Promise<void> {
    return new Promise((resolve, reject) => {
        let timesTried = 0;
        const display = getDisplayById(displayId);
        const schedName = `display_wait_initialized_${displayId}`;

        Scheduler.New()
            .Called(schedName)
            .HasAction(async function () {
                if (display.displayLoaded === true) {
                    Scheduler.Delete(schedName);
                    await display.playAllZones();
                    display.wrapperElement?.classList.remove('display--hidden');
                    display.wrapperElement?.classList.add('display--active');
                    resolve();
                } else {
                    timesTried++;
                    if (timesTried > 60) {
                        Scheduler.Delete(schedName);
                        const errMessage =
                            'Stream load timed out. All zones in content stream could not be loaded!';
                        Log.Warning(errMessage, null, __fileline);
                        reject(new Error(errMessage));
                    }
                }
            })
            .RunEvery(1000, 'ms');
    });
}

export async function switchDisplay(displayId: number): Promise<void> {
    // hide non-showing displays first (important for
    // stopAllZones and playAllZones logic)
    getDisplays().forEach(async function (display: Display) {
        if (display.id !== displayId) {
            Log.Info(`Hide Display: ${display.id}`, null, __fileline);
            await display.stopAllZones();
            display.wrapperElement?.classList.add('display--hidden');
            display.wrapperElement?.classList.remove('display--active');
        }
    });

    // show the display we want
    Log.Info(`Show Display: ${displayId}`, null, __fileline);
    await makeVisible(displayId);
    setCurrentDisplayId(displayId);
}
